import { render, staticRenderFns } from "./attached-view.vue?vue&type=template&id=c17ad4e0&scoped=true"
import script from "./attached-view.vue?vue&type=script&lang=js"
export * from "./attached-view.vue?vue&type=script&lang=js"
import style0 from "./attached-view.vue?vue&type=style&index=0&id=c17ad4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17ad4e0",
  null
  
)

export default component.exports